export const audio = new Audio()


// WEBPACK FOOTER //
// ./src/utils/audioText.js